const TableFloatFilter = (rows, columnIds, filterValue) => {
	const val = rows.original[columnIds];
	const startFilterValue = filterValue[0];
	const endFilterValue = filterValue[1];

	return (
		(startFilterValue !== null && startFilterValue !== '' && !isNaN(startFilterValue)
			? val >= filterValue[0]
			: true) &&
		(endFilterValue !== null && endFilterValue !== '' && !isNaN(endFilterValue) ? val <= filterValue[1] : true)
	);
};

// This is an autoRemove method on the filter function that
TableFloatFilter.autoRemove = (val) => val === undefined || val === null || val === '';

export default TableFloatFilter;
